/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Grid,
  Card,
  useMediaQuery,
  Chip,
  TextField,
  Autocomplete,
  ToggleButtonGroup,
  ToggleButton,
  Dialog,
  DialogTitle,
  DialogContent,
  useTheme,
  Button,
  FormControl,
  CircularProgress,
} from "@mui/material";
import { Field, reduxForm, getFormSyncErrors } from "redux-form";

import { Close, Search, ChevronRight } from "@mui/icons-material";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import SubFooterView from "components/SubFooterView";
import GenericListAndCouponView from "./SearchMedication/GenericListAndCouponView";
import BrandedCouponView from "./SearchMedication/BrandedCouponView";
import FooterView from "components/FooterView";
import { Link, useHistory } from "react-router-dom";
import { homeActions, gaugeActions } from "actions";
import { homeService } from "services";
import { renderCustomTextField } from "components/FormFields/FieldTypes";
import { zip as zipNormalizer } from "components/FormFields/normalizers";
import { zip as zipValidator } from "components/FormFields/validators";
import ZipcodeErrorMsg from "./SearchMedication/ZipcodeErrorMsg";

const PrescriptionsComponent = (props) => {
  const theme = useTheme();
  const {
    organizationInfo,
    jwtToken,
    match,
    getPrescriptionProducts,
    prescriptions,
    getCouponPriceForDiscountCardPrescription,
    getCouponPriceForCopayCardPrescription,
    couponLowestPrice,
    contentInfo,
    gtmInfo,
    getCityStateForZipCode,
    saveZipCodeToServer,
    formErrors,
    zipData,
    zipDataIsProgress,
    resetZipStatus,
  } = props;

  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };

  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const isSmallScreen = useMediaQuery("(max-width:1000px)");
  // const isShowBackgroundAssets =
  //   organizationInfo?.showBackgroundAssetsFlag?.toUpperCase() === "Y";
  const [qryProductName, setQueryProductName] = useState(
    match?.params?.productName || null
  );

  const [screenType, setScreenType] = useState(
    match?.params?.screenType || null
  );

  const [allProductsArr, setAllProductsArr] = useState([]);
  const [allProductsArrTemp, setAllProductsArrTemp] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [productsObj, setproductsObj] = useState(null);
  const [selectedSeries, setSelectedSeries] = useState(null);

  const [productData, setProductData] = useState(null);
  const [zipcodeError, setZipcodeError] = useState(false);
  // const matchesMinWidth = useMediaQuery("(max-width:400px)");
  const history = useHistory();

  const [alignment, setAlignment] = React.useState("price");

  // eslint-disable-next-line no-unused-vars
  const [couponOrGenericListTitle, setCouponOrGenericListTitle] =
    useState(null);

  const storedInsuranceData = JSON.parse(
    localStorage.getItem("storedInsuranceData")
  );
  const localStoredZipData = JSON.parse(localStorage.getItem("storedZipData"));

  const [storedZipData, setStoredZipData] = useState(null);
  const [zipcodeInput, setZipcodeInput] = useState(null);

  const zipSearch = () => {
    const zipValue = document.getElementsByName("zipCode")[0]?.value;
    if (zipValue && zipValue.length === 5) {
      getCityStateForZipCode(zipValue);
    }
  };

  useEffect(() => {
    setZipcodeError(false);
    if (
      !storedZipData?.zipCode &&
      !zipData?.zipCode &&
      !localStoredZipData?.zipCode &&
      !zipDataIsProgress
    ) {
      setZipcodeError(true);
    }
    if (zipData?.zipCode && !storedZipData?.zipCode) {
      setStoredZipData(zipData);
      saveZipCodeToServer(zipData?.zipCode);
      setZipcodeError(false);
    }
  }, [zipData]);

  useEffect(() => {
    return () => {
      resetZipStatus();
    };
  }, []);

  const handleChange = (newAlignment) => {
    setAlignment(newAlignment);
  };

  const fetchProducts = async () => {
    setproductsObj(prescriptions || {});
    if (!selectedSeries) {
      let firstSeries = Object.keys(prescriptions);
      const series = qryProductName
        ? qryProductName?.charAt(0).toUpperCase()
        : firstSeries[0];

      setSelectedSeries(series);
    }
    let arr = [];
    Object.keys(prescriptions).forEach((item) => {
      arr = arr.concat(prescriptions[item]);
    });
    setAllProductsArr(arr);
    setAllProductsArrTemp(arr);
  };

  useEffect(() => {
    if (Object.keys(prescriptions).length) {
      fetchProducts();
    }
  }, [prescriptions]);

  useEffect(() => {
    if (productsObj) {
      setProducts(productsObj[selectedSeries]);
      setSelectedProduct(null);
    }
  }, [selectedSeries]);

  useEffect(() => {
    console.log("prescriptions");
    console.log(prescriptions);
    if (Object.keys(prescriptions).length === 0) {
      getPrescriptionProducts();
    }
    if (localStoredZipData?.zipCode) {
      setStoredZipData(localStoredZipData);
    }
  }, []);

  useEffect(() => {
    if (
      jwtToken &&
      qryProductName &&
      screenType &&
      (screenType === "info" || screenType === "price") &&
      products?.length
    ) {
      const selectedProductArr = products.filter(
        (item) =>
          decodeURIComponent(match?.params?.productName)?.toLowerCase() ===
          item.productName?.toLowerCase()
      );
      if (selectedProductArr.length) {
        setSelectedProduct(selectedProductArr[0]);
        if (screenType === "info") {
          getProductData(selectedProductArr[0]?.productDetailId);
        }
        if (screenType === "price") {
          if (storedZipData && storedZipData?.zipCode) {
            const commericalInsData =
              contentInfo.INSURANCE_HELP_V2.contentParam.filter(
                (item) => item.value.type === "X"
              )[0];

            const payload = {
              productDetailId: selectedProductArr[0]?.productDetailId,
              quantity: 0,
              zipCode: storedZipData?.zipCode,
              insuranceId:
                selectedProductArr[0]?.type !== "B"
                  ? storedInsuranceData?.id
                  : commericalInsData?.value?.id,
            };
            if (selectedProductArr[0]?.type === "B") {
              getCouponPriceForCopayCardPrescription(payload);
            } else {
              getCouponPriceForDiscountCardPrescription(payload);
            }
          } else {
            setZipcodeError(true);
          }
        }
      } else {
        setSelectedProduct(null);
        setQueryProductName(null);
        setScreenType(null);
        history.push("/savings");
      }
    }
  }, [jwtToken, match?.params?.productName, products, storedZipData]);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer,
    });
  }, [gtmInfo]);

  const getProductData = (productDetailId) => {
    setLoading(true);
    homeService
      .getProductInfo(productDetailId)
      .then((res) => {
        // if (res?.data?.success) {
        //   setProductData(res);
        // } else {
        //   setSelectedProduct(null);
        //   setQueryProductName(null);
        // }
        // setLoading(false);

        setProductData(res);
        setLoading(false);
      })
      .catch(() => {
        // updateGTMDataLayer({
        //   event: "VIEW_PRODUCT_INFO",
        // });
        setLoading(false);
      });
  };

  const renderHeader = () => {
    return (
      <>
        <Grid
          container
          mt={1}
          spacing={1}
          sx={{ display: "flex", justifyContent: "end" }}
        >
          <ToggleButtonGroup
            color="primary"
            value={alignment}
            exclusive
            aria-label="Platform"
          >
            <ToggleButton
              onClick={() => handleChange("price")}
              sx={{
                backgroundColor:
                  alignment === "price"
                    ? `${theme.palette.secondary.main} !important`
                    : undefined,
                color:
                  alignment === "price"
                    ? `${theme.palette.secondary.hoverOneText} !important`
                    : undefined,
              }}
              value="price"
            >
              Price
            </ToggleButton>
            <ToggleButton
              onClick={() => handleChange("info")}
              sx={{
                backgroundColor:
                  alignment === "info"
                    ? `${theme.palette.secondary.main} !important`
                    : undefined,
                color:
                  alignment === "info"
                    ? `${theme.palette.secondary.hoverOneText} !important`
                    : undefined,
              }}
              value="info"
            >
              Info
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid
          sx={{
            display: matchesMinWidth ? "block" : "flex",
            alignItems: "baseline",
          }}
          container
        >
          <Grid container item xs={matchesMinWidth ? 12 : 4}>
            <Autocomplete
              value={selectedProduct}
              onChange={(event, newInputValue) => {
                if (alignment === "price") {
                  if (!storedZipData) {
                    setZipcodeError(true);
                  } else {
                    history.push(
                      `/savings/${encodeURIComponent(
                        newInputValue.productName
                      )}/price`
                    );
                  }
                } else {
                  setZipcodeError(false);
                  history.push(
                    `/savings/${encodeURIComponent(
                      newInputValue.productName
                    )}/info`
                  );
                }
              }}
              freeSolo
              options={allProductsArr || []}
              getOptionLabel={(option) => option.productName}
              className="auto-complete-input"
              clearIcon={
                <Close
                  // onClick={() => props.resetInsuranceFilterData()}
                  fontSize="small"
                />
              }
              filterOptions={(all) => {
                return all;
              }}
              renderOption={(event, option, { inputValue }) => {
                const name = option?.productName?.replace(
                  new RegExp(inputValue, "gi"),
                  (match) => `<b>${match}</b>`
                );
                return (
                  <Box
                    className="auto-complete-list-container"
                    key={option?.productDetailId}
                    onClick={() => {
                      if (alignment === "price") {
                        if (!storedZipData) {
                          setZipcodeError(true);
                        } else {
                          history.push(
                            `/savings/${encodeURIComponent(
                              option.productName
                            )}/price`
                          );
                        }
                      } else {
                        setZipcodeError(false);
                        history.push(
                          `/savings/${encodeURIComponent(
                            option.productName
                          )}/info`
                        );
                      }
                    }}
                  >
                    <Box
                      className="search-list-view"
                      dangerouslySetInnerHTML={{ __html: name }}
                    ></Box>
                    <ChevronRight className="right-icon" />
                  </Box>
                );
              }}
              sx={{ width: 300 }}
              renderInput={(params) => (
                <Box>
                  <Typography
                    variant="h4LatoBold"
                    sx={{
                      fontSize: "24px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    Search by drug name
                  </Typography>
                  <Box sx={{ position: "relative" }} mt={1}>
                    <TextField
                      {...params}
                      variant="standard"
                      onChange={(event) => {
                        const text = event.target.value;
                        if (
                          event?.target?.value &&
                          event.target.value.length > 2
                        ) {
                          let filteredProductsArr = allProductsArrTemp.filter(
                            (item) => {
                              return item.productName
                                .toLowerCase()
                                .includes(text);
                            }
                          );
                          console.log(filteredProductsArr);
                          setAllProductsArr(filteredProductsArr);
                        }
                      }}
                    />
                    <Search
                      sx={{
                        color: `${organizationInfo?.colorSchemeJson?.primaryButtonColor} !important`,
                      }}
                      className="search-icon"
                    />
                  </Box>
                </Box>
              )}
            />
            <Box mb={3} sx={{ textAlign: "center" }}></Box>
          </Grid>

          <Grid
            mt={matchesMinWidth ? 3 : 1}
            container
            sx={{ lineHeight: "50px" }}
            item
            xs={matchesMinWidth ? 12 : 8}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                lineHeight: "50px",
              }}
            >
              <Typography variant="h4LatoBold" sx={{ fontSize: "24px" }}>
                Browse drugs
              </Typography>
            </Grid>
            <Grid container mt={-1} spacing={1} sx={{ display: "flex" }}>
              {productsObj &&
                Object.keys(productsObj).length &&
                Object.keys(productsObj).map((item, index) => (
                  <Grid
                    key={"product_" + index}
                    sx={{
                      paddingLeft: "0px !important",
                      paddingTop: matchesMinWidth
                        ? undefined
                        : "4px !important",
                    }}
                    pt={0}
                    pb={0}
                    container
                    item
                    xs={matchesMinWidth ? 2 : 0.55}
                  >
                    <Chip
                      className="drug-series"
                      onClick={() => {
                        setSelectedSeries(item);
                        setSelectedProduct(null);
                      }}
                      label={item}
                      sx={{
                        width: "32px",
                        backgroundColor:
                          selectedSeries === item
                            ? `${theme.palette.secondary.main} !important`
                            : undefined,
                        color:
                          selectedSeries === item
                            ? `${theme.palette.secondary.hoverOneText} !important`
                            : undefined,
                        textOverflow: "clip",
                      }}
                      variant="outlined"
                      clickable={selectedSeries !== item}
                    />
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <Box sx={{ overflowY: "auto" }}>
      {selectedProduct?.productDetailId ? (
        <Helmet>
          <title>
            {`${qryProductName} Coupons Cost Info for 2023 - Save up to 80% with ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            }`}
          </title>

          <meta
            name="description"
            content={`Get the best price on ${qryProductName} at pharmacies near you with ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            }. Save up to 80% with our ${qryProductName} coupons — with or without insurance!`}
          />
          <meta
            property="og:title"
            content={`${qryProductName} Coupons  Cost Info for 2023 - Save up to 80% with ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            }`}
          />
          <meta
            property="og:description"
            content={`Get the best price on ${qryProductName} at pharmacies near you with ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            }. Save up to 80% with our ${qryProductName} coupons — with or without insurance!`}
          />
          <meta
            property="og:image"
            content="assets/images/cuverd-logo-header.png"
          />
          <link
            rel="alternate"
            href="https://www.cuverd.com/savings"
            hrefLang="en-us"
          />
          <meta
            data-react-helmet="true"
            property="og:site_name"
            content={`${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            }`}
          ></meta>
          <meta
            data-react-helmet="true"
            property="og:type"
            content="website"
          ></meta>
          <link rel="canonical" href="https://www.cuverd.com/savings" />
        </Helmet>
      ) : (
        <Helmet>
          <title>
            {`Browse Prescriptions ${
              selectedSeries ? "Starting With " + selectedSeries : ""
            } | ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            }`}
          </title>
          <meta
            name="description"
            content={`Top prescriptions on ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            } ${
              selectedSeries ? "starting with the letter " + selectedSeries : ""
            }. ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            } can help you save up to 80% on your prescription. Find your prescription on ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            } and see how much you can save.`}
          />
          <meta
            property="og:title"
            content={`Browse Prescriptions ${
              selectedSeries ? "Starting With " + selectedSeries : ""
            } | ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            }`}
          />
          <meta
            property="og:description"
            content={`Top prescriptions on ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            } ${
              selectedSeries ? "starting with the letter " + selectedSeries : ""
            }. ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            } can help you save up to 80% on your prescription. Find your prescription on ${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : organizationInfo?.name
            } and see how much you can save.`}
          />
          <meta
            property="og:image"
            content="assets/images/cuverd-logo-header.png"
          />
          <link
            rel="alternate"
            href="https://www.cuverd.com/savings"
            hrefLang="en-us"
          />
          <meta
            data-react-helmet="true"
            property="og:site_name"
            content={`${
              organizationInfo?.app?.appCode === "CVD"
                ? "Cuverd® Partner"
                : "Cuverd®"
            }`}
          ></meta>
          <meta
            data-react-helmet="true"
            property="og:type"
            content="website"
          ></meta>
          og:site_name
          <link rel="canonical" href="https://www.cuverd.com/savings" />
        </Helmet>
      )}

      <Box>
        <Grid container alignItems="center">
          <Grid
            item
            sm={12}
            xs={12}
            mt={2}
            mb={2}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              sx={{
                maxHeight: "1000px",
                width: matchesMinWidth ? "100%" : "88%",
                paddingLeft:
                  screenType === "price" && isSmallScreen
                    ? undefined
                    : isSmallScreen
                    ? "1rem"
                    : "4rem",
                paddingRight:
                  screenType === "price" && isSmallScreen
                    ? undefined
                    : isSmallScreen
                    ? "1rem"
                    : "4rem",
                paddingTop:
                  screenType === "price" && isSmallScreen ? undefined : "2rem",
                paddingBottom:
                  screenType === "price" && isSmallScreen ? undefined : "2rem",
              }}
            >
              {productsObj && !selectedProduct && renderHeader()}
              {!selectedProduct && selectedSeries && (
                <>
                  <Grid mt={matchesMinWidth ? 3 : 5} container spacing={1}>
                    <Grid
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        lineHeight: "50px",
                      }}
                    >
                      <Typography
                        variant="h4LatoBold"
                        sx={{ fontSize: "28px" }}
                      >
                        Drugs starts with "{selectedSeries}"
                      </Typography>
                    </Grid>
                    <Grid
                      mt={matchesMinWidth ? 0 : 1}
                      container
                      style={{
                        height: "30vh",
                        //justifyContent: "center",
                        flexDirection: "row",
                        overflow: "hidden",
                        overflowY: "scroll",
                        scrollBehavior: "smooth",
                      }}
                      item
                      spacing={2}
                    >
                      {products.map((item) => {
                        return (
                          <Grid
                            container
                            item
                            xs={matchesMinWidth ? 12 : 3}
                            key={`${item.productName}_${item.productDetailId}`}
                            sx={{
                              maxWidth: matchesMinWidth
                                ? "100% !important"
                                : "20% !important",
                            }}
                          >
                            <Chip
                              sx={{ color: "#607277" }}
                              label={item.productName}
                              variant="h4LatoRegular"
                              clickable
                              component={Link}
                              size="small"
                              onClick={() => {
                                if (alignment === "price" && !storedZipData) {
                                  setZipcodeError(true);
                                }
                              }}
                              to={
                                alignment === "price" &&
                                storedZipData &&
                                storedZipData?.zipCode
                                  ? "/savings/" +
                                    encodeURIComponent(item.productName) +
                                    "/price"
                                  : alignment === "info"
                                  ? "/savings/" +
                                    encodeURIComponent(item.productName) +
                                    "/info"
                                  : "/savings"
                              }
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                </>
              )}
              {selectedProduct?.productDetailId && screenType === "info" && (
                <Box mb={7}>
                  <Grid container spacing={1}>
                    <Chip
                      sx={{ width: matchesMinWidth ? "16%" : "10%" }}
                      label={"Back"}
                      variant="outlined"
                      clickable
                      component={Link}
                      to={"/savings"}
                    />

                    <Typography
                      variant="h4LatoBold"
                      component={"div"}
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "24px",
                      }}
                    >
                      {selectedProduct?.productName}
                    </Typography>
                  </Grid>
                  {productData?.data?.pemURL && (
                    <iframe
                      src={`${productData?.data?.pemURL}`}
                      frameBorder="0"
                      border="0"
                      cellSpacing="0"
                      style={{
                        height: "800px",
                        borderStyle: "none",
                        width: "100%",
                      }}
                      title="Details"
                      scrolling="yes"
                    ></iframe>
                  )}
                  {productData?.success === false && (
                    <Typography
                      variant="h4LatoBold"
                      component={"div"}
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "16px",
                      }}
                    >
                      {productData?.message}
                    </Typography>
                  )}
                </Box>
              )}
              <ZipcodeErrorMsg initialize={props.initialize} />
              {zipcodeError && (
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  // onClose={() => {
                  //   history.push("/");
                  //   setZipcodeError(false);
                  // }}
                  open={zipcodeError}
                  className="app-dialog"
                >
                  <DialogTitle sx={{ color: "#002060", textAlign: "center" }}>
                    <Typography
                      variant="h4LatoBold"
                      component={"div"}
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "24px",
                      }}
                    >
                      Enter Zip Code
                    </Typography>
                  </DialogTitle>
                  <DialogContent
                    sx={{
                      paddingLeft: matchesMinWidth ? "24px" : "40px",
                      paddingRight: matchesMinWidth ? "24px" : "40px",
                    }}
                  >
                    {zipDataIsProgress && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        mt={2}
                      >
                        <CircularProgress
                          style={{ color: theme?.palette?.secondary?.main }}
                        />
                      </Box>
                    )}
                    {!zipDataIsProgress && (
                      <>
                        <Grid
                          mt={2}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <FormControl variant="standard">
                            <Field
                              type="number"
                              name="zipCode"
                              id="zipCode"
                              onChange={(e) => {
                                const val = e.target.value;

                                setZipcodeInput(val);
                              }}
                              component={renderCustomTextField}
                              label={"Zip Code"}
                              normalize={zipNormalizer}
                              validate={zipValidator}
                            />
                          </FormControl>
                        </Grid>
                        <Grid
                          mt={6}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Button
                            sx={{ minWidth: "20%", marginRight: "5%" }}
                            variant="large"
                            onClick={() => {
                              zipSearch();
                            }}
                            disabled={
                              Object.keys(formErrors).length ||
                              !zipcodeInput ||
                              !zipcodeInput.length === 5
                            }
                          >
                            OK
                          </Button>

                          {/* <Button
                  variant="text"
                  sx={{
                    minWidth: "20%",
                    textDecoration: "underline",
                    //color: `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                  }}
                  onClick={() => {
                    localStorage.removeItem("storedZipData");
                    history.push("/");
                    setZipcodeError(false);
                  }}
                >
                  CANCEL
                      </Button> */}

                          <Button
                            sx={{ minWidth: "20%" }}
                            variant="large"
                            onClick={() => {
                              localStorage.removeItem("storedZipData");
                              history.push("/");
                              setZipcodeError(false);
                            }}
                          >
                            CANCEL
                          </Button>
                        </Grid>
                      </>
                    )}
                  </DialogContent>
                </Dialog>
              )}
              {selectedProduct?.productDetailId &&
                !zipcodeError &&
                screenType === "price" && (
                  <Card
                    sx={{
                      width: matchesMinWidth ? "100%" : "65%",
                    }}
                  >
                    {selectedProduct?.type !== "B" ? (
                      <GenericListAndCouponView
                        {...props}
                        showGauge={false}
                        selectedPrescription={selectedProduct}
                        searchGaugeView={true}
                        couponOrGenericListTitle={couponOrGenericListTitle}
                        backToSearchGauge={() => history.push("/savings")}
                        couponLowestPrice={couponLowestPrice}
                        fromPrescriptions={true}
                      />
                    ) : (
                      <BrandedCouponView
                        {...props}
                        selectedPrescription={selectedProduct}
                        searchGaugeView={true}
                        showGauge={false}
                        backToSearchGauge={() => history.push("/savings")}
                        openSearchSettings={() => {
                          // setSavingsBtnAutoForward(false);
                          // setShowGauge(true);
                          // setOpenSearchButton(true);
                          // setGaugeInit(false);
                          // setEditFromInsurace(true);
                        }}
                        fromPrescriptions={true}
                        couponLowestPrice={couponLowestPrice}
                      />
                    )}
                  </Card>
                )}
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <SubFooterView />
        <FooterView />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("SEND_SAVINGS_ZIPCODE_FORM")(state) || {},
    prescriptions: state.prescriptions.data || {},
    organizationInfo: state.organizationInfo.data || {},
    jwtToken: state.authentication.jwtToken,
    couponLowestPrice: state.couponPrice.lowestPrice,
    contentInfo: state.contentType.data,
    gtmInfo: state.gtmInfo.data,
    zipData: state.zipData.data,
    zipDataIsProgress: state.zipData.isProgress,
    zipDataError: state.zipData.error,
  };
};

const actionCreators = {
  getPrescriptionProducts: () => homeActions.getPrescriptionProducts(),
  getCouponPriceForDiscountCardPrescription: (params) =>
    gaugeActions.getCouponPrice(params),
  getCouponPriceForCopayCardPrescription: (params) =>
    gaugeActions.getCouponPriceForCopayCardPrescription(params),
  getCityStateForZipCode: (value) => homeActions.getCityStateForZipCode(value),
  saveZipCodeToServer: (value) => homeActions.saveZipCodeToServer(value),
  resetZipStatus: () => homeActions.resetZipStatus(),
};

export default connect(
  mapStateToProps,
  actionCreators
)(
  reduxForm({
    form: "SEND_SAVINGS_ZIPCODE_FORM",
  })(PrescriptionsComponent)
);
